import type {
  CreateReviewRequest,
  CreateReviewResponse,
  GetUserReviewResponse,
  DeleteUserReviewResponse,
} from '@mrb91002/shared-types'

import { secureFetch, SECURE_API_BASE } from './helpers'

export async function createOrUpdateReview(
  patternId: string,
  reviewData: CreateReviewRequest,
  idToken: string,
): Promise<CreateReviewResponse> {
  return secureFetch<CreateReviewResponse>(`${SECURE_API_BASE}/pattern/${encodeURIComponent(patternId)}/review`, idToken, {
    method: 'POST',
    body: JSON.stringify(reviewData),
  })
}

export async function createOrUpdateMaterialReview(
  materialId: string,
  reviewData: CreateReviewRequest,
  idToken: string,
): Promise<CreateReviewResponse> {
  return secureFetch<CreateReviewResponse>(`${SECURE_API_BASE}/material/${encodeURIComponent(materialId)}/review`, idToken, {
    method: 'POST',
    body: JSON.stringify(reviewData),
  })
}

export async function getUserReview(patternId: string, idToken: string): Promise<GetUserReviewResponse> {
  return secureFetch<GetUserReviewResponse>(`${SECURE_API_BASE}/pattern/${encodeURIComponent(patternId)}/my-review`, idToken, {
    method: 'GET',
  })
}

export async function deleteUserReview(patternId: string, idToken: string): Promise<DeleteUserReviewResponse> {
  return secureFetch<DeleteUserReviewResponse>(`${SECURE_API_BASE}/pattern/${encodeURIComponent(patternId)}/my-review`, idToken, {
    method: 'DELETE',
  })
}
